// styles
import "./index.css";

// router
import MainNavigation from "./router";

// environment
import env from "./config/env";

// store
import { Provider } from "react-redux";
import { store } from "./store";

// disable dev mode
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

if (env.enviroment === "production") {
  disableReactDevTools();
}

const App = () => {
  return (
    <Provider store={store}>
      <MainNavigation />
    </Provider>
  );
};

export default App;
